import { useCallback } from 'react'
import { omit } from '@nwwp/utils'
import { useSegmentAnalytics } from '../components/Provider'

type TrackElementInteractedParams = {
  element: string
  eventName?: string
} & Record<string, unknown>
export const useTrackElementInteracted = () => {
  const analytics = useSegmentAnalytics()

  return useCallback(
    (params: TrackElementInteractedParams) => {
      return analytics.track(params.eventName ?? 'Element Interacted', {
        ...omit(params, ['element', 'eventName']),
        element: params.element,
      })
    },
    [analytics]
  )
}
